function setUserFormSaving({ state }) {
  state.set('client.forms', {
    isSubmitting: false,
    snackbar: { show: false, success: false }
  })
}

export default setUserFormSaving



// WEBPACK FOOTER //
// ./src/modules/app/actions/setUserFormSaving.js